import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

interface DramaCardProps {
  drama: Drama;
  rank?: number;
}

export default function DramaCard({ drama, rank }: DramaCardProps) {
  return (
    <article className="group h-full flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/dramas/${drama.id}`} className="block relative">
        <div className="w-full aspect-[3/4] bg-background-200 overflow-hidden">
          <img
            src={drama.cover}
            alt={`${drama.title} 短剧封面，题材：${drama.category}`}
            title={`${drama.title} - 爆料短剧真实事件改编对照`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.03] transition-transform duration-500"
          />
        </div>
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-medium whitespace-nowrap">
          {drama.category}
        </span>
        {typeof rank === 'number' && (
          <span className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-md bg-foreground-950/80 text-background-50 font-label text-xs">
            {String(rank).padStart(2, '0')}
          </span>
        )}
        <span className="absolute bottom-3 left-3 px-2 py-1 rounded-md bg-foreground-950/75 text-background-50 text-[11px] whitespace-nowrap">
          {drama.confirmLevel}
        </span>
      </Link>

      <div className="flex flex-col flex-1 p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug">
          <Link to={`/dramas/${drama.id}`} className="hover:text-primary-600 transition-colors">
            《{drama.title}》
          </Link>
        </h3>
        <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
          {drama.subtitle}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {drama.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-900 text-[11px] whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-4">
          <div className="flex items-center justify-between text-[11px] text-foreground-500 mb-1.5">
            <span>综合还原度</span>
            <span className="font-label text-primary-600">{drama.adaptationScore}%</span>
          </div>
          <div className="h-1.5 w-full rounded-full bg-background-200 overflow-hidden">
            <div
              className="h-full rounded-full bg-primary-500"
              style={{ width: `${drama.adaptationScore}%` }}
            ></div>
          </div>
          <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-400">
            <span>{drama.year} · {drama.episodes} 集</span>
            <span className="flex items-center gap-1">
              <i className="ri-fire-line text-accent-500"></i>
              热度 {drama.hot}
            </span>
          </div>
        </div>
      </div>
    </article>
  );
}